const moment = require('moment');

/**
 * @param {streamID} string - selector for tile (ie: data-source-stream-id="3314489")
 * Function takes all given tiles and formats the date
 * @return {undefined}
 **/

module.exports = function formatDate(streamId) {
    const timestamp = document.querySelectorAll(`.tile[${streamId}] .friendly-timestamp .timeago`);
    if (timestamp) {
        const changDate = (dateArray, dateSelector) => {
            for (let i = 0; i < dateArray.length; i++) {
                const element = dateArray[i];
                const currentDate = dateSelector === 'innerHTML' ? moment(element.innerHTML).format('MMMM D, YYYY') : moment(element.title).format('MMMM D, YYYY');
                currentDate !== 'Invalid Date' ? element.innerHTML = currentDate : '';
            }
        };

        changDate(timestamp, 'title');
    }
};


// WEBPACK FOOTER //
// ./custom-modules/dateFormat.js